import i18nCountries from 'i18n-iso-countries';

export const isUserHaveUnitedStatesCountry = (country: string) => {
  return i18nCountries.getName('US', 'en') === country;
};
